import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Order } from "../../types/api/Order";

interface AddAddressToOrderBody {
  orderId: string;
  addressId: string;
}

export default (
  cartId: string | undefined,
  sellerOrgId: string,
  buyerOrgId: string
) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Order, null, AddAddressToOrderBody>(
    `address_${cartId}`,
    async (body: AddAddressToOrderBody) =>
      Put(
        `/api/order/${body.orderId}/shipping_address?address_id=${body.addressId}`,
        await getAccessTokenSilently()
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          `current_cart_${sellerOrgId}_${buyerOrgId}`,
        ]);
      },
    }
  );
};
